<template>
  <h3
    class="title1-container"
    :class="[content.titleImage ? 'title1-image-container' : '', device.isMobile ? 'title1-container-mobile' : '']"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
      marginTop: (content.textStyle.marginTop + 'rem') || '',
      marginBottom: (content.textStyle.marginBottom + 'rem') || '',
    }"
  >
    <img class="title-image" v-if="content.titleImage" :src="content.titleImage" alt="">
    <span class="title-text" :id="`${content.key}-1`">
      <span :id="`${content.key}-1-1`" v-html="content.shortText"></span>
      <span :id="`${content.key}-1-2`" v-html="content.text"></span>
    </span>
  </h3>
</template>
<script>
/*
标题-1
*/
export default {
  name: "title-1",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title1-container{
  margin-bottom: 30rem;
  width: 100%;
  height: 168rem;
  background: url(~@/assets/images/books/bookExample/section_title_bg.png) center center no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36rem;
  color: #98e1e2;
  line-height: 54rem;

  .title-text{
    text-align: center;
    margin-top: -5rem;
    
    span{
      display: block;
      font-size: 36rem;
      line-height: 54rem;
      color: #fff;
    }
  }
}
.title1-image-container{
  height: auto;
  position: relative;
  .title-image{
    width: 100%;
    height: auto;
  }
  .title-text{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.title1-container-mobile{
  margin-bottom: 50rem;
}
</style>